class FacetGenerator extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.url = new URL(window.location.href);
    this.params = this.getParams();

    this.setCheckedInputs();
  }

  getParams() {
    return this.url.searchParams.getAll("filter.p.tag");
  }

  updateParams() {
    this.url = new URL(window.location.href);
    this.params = this.getParams();
    this.render();
  }

  generateFacets() {
    const baseUrl = this.url.origin + this.url.pathname;
    let html = '<div class="active-facets active-facets-desktop lap-hide">';

    console.log(this.params)

    this.params.forEach((param, index) => {
      const otherParams = this.params.filter((_, i) => i !== index);
      const otherParamsUrl = otherParams
        .map(p => `filter.p.tag=${encodeURIComponent(p)}`)
        .join("&");

      html += `<a class="pill pill--has-close js-facet-remove" href="${baseUrl}?${otherParamsUrl}">
                  <span></span>
                  ${this.formatLabel(param)}
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="5.90405" y="5.19678" width="14" height="1" transform="rotate(45 5.90405 5.19678)" fill="black"></rect>
                    <rect x="15.8035" y="5.90381" width="14" height="1" transform="rotate(135 15.8035 5.90381)" fill="black"></rect>
                  </svg>
                </a>`;
    });

    if(this.params.length > 0){
      html += `<a href="${baseUrl}" class="text-decoration--underline js-facet-remove">Clear all</a></div>`;
    }

    return html;
  }

  setCheckedInputs() {
    this.params.forEach(param => {
      const inputs = document.querySelectorAll('input[name="filter.p.tag"]');
      inputs.forEach(input => {
        if (input.value === param) {
          input.checked = true;
        }
      });
    });
  }

  // Da formato al label eliminando los "+" y reemplazándolos por espacios
  formatLabel(label) {
    return label.replace(/\+/g, ' ');
  }

  // Conecta el componente al DOM
  connectedCallback() {
    this.shadowRoot.innerHTML = `
      <style>
        .active-facets {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .pill {
          background-color: #f0f0f0;
          padding: 5px 10px;
          border-radius: 20px;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          text-decoration: none;
          color: black;
        }
        .pill--has-close svg {
          margin-left: 5px;
        }
        .text-decoration--underline {
          text-decoration: underline;
        }
      </style>
      ${this.generateFacets()}
    `;
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .active-facets {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .pill {
          background-color: #f0f0f0;
          padding: 5px 10px;
          border-radius: 20px;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          text-decoration: none;
          color: black;
        }
        .pill--has-close svg {
          margin-left: 5px;
        }
        .text-decoration--underline {
          text-decoration: underline;
        }
      </style>
      ${this.generateFacets()}
    `;
  }
}

// Definir el elemento personalizado
customElements.define('facet-generator', FacetGenerator);


const updateWebComponentWithNewParams = () => {
  const facetComponent = document.querySelector('facet-generator');
  if (facetComponent) {
    facetComponent.updateParams();
  }
}